import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Stack, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DraggableDialog from './DraggableDialog';
import { RootState } from '../../store';
import { hideResultDialog } from '../../store/slices/uiSlice';

const ResultDialog: React.FC = () => {
  const dispatch = useDispatch();
  const { resultDialog } = useSelector((state: RootState) => state.ui);
  const navigate = useNavigate();

  const icon = (() => {
    switch (resultDialog.severity) {
      case 'success':
        return <CheckCircleOutlineIcon color="success" />;
      case 'error':
        return <ErrorOutlineIcon color="error" />;
      case 'warning':
        return <WarningAmberIcon color="warning" />;
      default:
        return <InfoOutlinedIcon color="info" />;
    }
  })();

  return (
    <DraggableDialog
      open={resultDialog.open}
      onClose={() => dispatch(hideResultDialog())}
      title={resultDialog.title}
      maxWidth="sm"
      fullWidth
      actions={
        <Button
          onClick={() => {
            const path = String(resultDialog.nextPath || '').trim();
            dispatch(hideResultDialog());
            if (path) navigate(path);
          }}
        >OK</Button>
      }
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box sx={{ pt: 0.5 }}>{icon}</Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            {resultDialog.message}
          </Typography>
          {resultDialog.details ? (
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
              {resultDialog.details}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </DraggableDialog>
  );
};

export default ResultDialog;
